import { createFileRoute, redirect } from '@tanstack/react-router'
import { PayrollRunDetailScreen } from '@/features/payroll-runs/payroll-run-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one run's review.
 *
 * Same grant as the list. Whether the caller may see THIS run is the API's
 * answer, not the browser's: tenancy scoping makes another company's run a
 * 404, which the screen surfaces.
 */
export const Route = createFileRoute('/_authenticated/payroll/runs/$runId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'payroll_run.view')) {
      throw redirect({ to: '/payroll/runs' })
    }
  },
  component: PayrollRunDetailRoute,
})

function PayrollRunDetailRoute() {
  const { runId } = Route.useParams()

  return <PayrollRunDetailScreen runId={runId} />
}
